import { render, staticRenderFns } from "./multiple.vue?vue&type=template&id=34c3c6da&scoped=true&"
import script from "./multiple.vue?vue&type=script&lang=js&"
export * from "./multiple.vue?vue&type=script&lang=js&"
import style0 from "./multiple.vue?vue&type=style&index=0&id=34c3c6da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c3c6da",
  null
  
)

export default component.exports